document.addEventListener('DOMContentLoaded',()=>{const toggle=document.querySelector('[data-menu-toggle]');const menu=document.querySelector('[data-mobile-menu]');if(toggle&&menu){toggle.addEventListener('click',()=>{const open=toggle.getAttribute('aria-expanded')==='true';toggle.setAttribute('aria-expanded',String(!open));menu.hidden=open;});}document.querySelectorAll('form.product-form').forEach(form=>{form.addEventListener('submit',()=>{const button=form.querySelector('button[type="submit"]');if(button&&!button.disabled){button.dataset.originalText=button.textContent;button.textContent='A adicionar…';}});});});


/* Pets&Casa wishlist: shared localStorage key for product cards and favorites page. */
(function () {
  const KEY = 'petsecasa_favorites_v1';
  function readFavorites() {
    try { const value = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(value) ? value : []; }
    catch (e) { return []; }
  }
  function writeFavorites(items) {
    try { localStorage.setItem(KEY, JSON.stringify(items)); } catch (e) {}
  }
  function syncButtons() {
    const ids = new Set(readFavorites().map(item => String(item.id)));
    document.querySelectorAll('[data-favorite-toggle]').forEach(button => {
      const active = ids.has(String(button.dataset.productId));
      button.setAttribute('aria-pressed', String(active));
      button.classList.toggle('is-favorite', active);
      button.innerHTML = button.classList.contains('favorite-toggle-product')
        ? (active ? '♥ Guardado nos favoritos' : '♡ Guardar nos favoritos')
        : (active ? '♥' : '♡');
      button.setAttribute('aria-label', active ? 'Remover dos favoritos' : 'Adicionar aos favoritos');
    });
  }
  function renderFavorites() {
    const list = document.querySelector('[data-favorites-list]');
    if (!list) return;
    const items = readFavorites();
    if (!items.length) {
      list.innerHTML = '<div class="favorites-empty"><p>Ainda não adicionou produtos aos favoritos.</p><a class="button button-primary" href="/collections/all">Explorar produtos</a></div>';
      return;
    }
    list.innerHTML = items.map(item => `
      <article class="favorite-card">
        <a class="favorite-card-image" href="${escapeAttr(item.url)}">${item.image ? `<img src="${escapeAttr(item.image)}" alt="${escapeAttr(item.title)}" loading="lazy">` : '<span>🐾</span>'}</a>
        <div class="favorite-card-info"><h2><a href="${escapeAttr(item.url)}">${escapeHtml(item.title)}</a></h2><p>${escapeHtml(item.price || '')}</p><a class="button button-primary" href="${escapeAttr(item.url)}">Ver produto</a><button type="button" class="favorite-remove" data-remove-favorite="${escapeAttr(item.id)}">Remover dos favoritos</button></div>
      </article>`).join('');
  }
  function escapeHtml(value) { return String(value || '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c])); }
  function escapeAttr(value) { return escapeHtml(value); }
  document.addEventListener('click', function (event) {
    const toggle = event.target.closest('[data-favorite-toggle]');
    if (toggle) {
      const item = { id: String(toggle.dataset.productId || ''), title: toggle.dataset.productTitle || 'Produto', url: toggle.dataset.productUrl || '/collections/all', image: toggle.dataset.productImage || '', price: toggle.dataset.productPrice || '' };
      if (!item.id) return;
      const items = readFavorites();
      const index = items.findIndex(existing => String(existing.id) === item.id);
      if (index >= 0) items.splice(index, 1); else items.push(item);
      writeFavorites(items); syncButtons(); renderFavorites();
      return;
    }
    const remove = event.target.closest('[data-remove-favorite]');
    if (remove) {
      const id = String(remove.dataset.removeFavorite);
      writeFavorites(readFavorites().filter(item => String(item.id) !== id));
      renderFavorites(); syncButtons();
    }
  });
  document.addEventListener('DOMContentLoaded', function () { syncButtons(); renderFavorites(); });
  if (document.readyState !== 'loading') { syncButtons(); renderFavorites(); }
  window.addEventListener('storage', function (event) { if (event.key === KEY) { syncButtons(); renderFavorites(); } });
})();
